export default __webpack_public_path__ + "static/media/eq.4c3b4b37.svg";